import {track} from '@getmoss/moss-analytics'
import {useCallback} from 'react'
import {useGetDomainCountry} from 'src/common/hooks/useGetDomainCountry'

export const useSpendBenchmarksTracking = () => {
  const domainCountry = useGetDomainCountry()

  const trackClick = useCallback(
    (element: string, details?: Record<string, unknown>) => {
      track({
        event: 'interaction',
        page: {domainCountry, type: 'spend-benchmarks', details},
        interaction: {type: 'click', element, location: 'spend_benchmarks'},
      })
    },
    [domainCountry],
  )

  return {trackClick}
}
